// Keep this function self-contained: SSR embeds it before Gatsby starts routing.
function recoverSocialLink(location, repairProductPath = false) {
    const {pathname, search, hash} = location;
    let correctedPath = pathname;
    for (let pass = 0; pass < 5; pass++) {
        const decodedPath = correctedPath.replace(/%25([0-9a-f]{2})/gi, "%$1");
        if (decodedPath === correctedPath) break;
        correctedPath = decodedPath;
    }

    const fragment = correctedPath.match(/^\/%23([^/]+)\/?$/i);
    if (fragment) return `/${search}#${fragment[1]}${hash}`;

    if (repairProductPath && pathname.startsWith("/shop/products/") && correctedPath !== pathname) {
        return `${correctedPath}${search}${hash}`;
    }

    return null;
}

module.exports = {recoverSocialLink};
